import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "../Components/Common/withRouter";

//redux
import { useSelector } from "react-redux";

const NonAuthLayout = ({ children }) => {
  const { layoutModeType } = useSelector((state) => ({
    layoutModeType: state.Layout.layoutModeType,
  }));

  useEffect(() => {
    if (layoutModeType === "dark") {
      document.body.setAttribute("data-layout-mode", "dark");
    } else {
      document.body.setAttribute("data-layout-mode", "light");
    }
    return () => {
      document.body.removeAttribute("data-layout-mode");
    };
  }, [layoutModeType]);
  return <div>{children}</div>;
};

NonAuthLayout.propTypes = {
  children: PropTypes.element,
};

export default withRouter(NonAuthLayout);
